"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TMEDistributorAttributesSchema = exports.VericalDistributorAttributesSchema = exports.ArrowDistributorAttributesSchema = exports.LCSCDistributorAttributesSchema = exports.MouserDistributorAttributesSchema = exports.DigikeyDistributorAttributesSchema = exports.DistributorAttributesSchema = exports.distributorUids = void 0;
exports.isDigikeyAttributes = isDigikeyAttributes;
exports.isMouserAttributes = isMouserAttributes;
exports.isLCSCAttributes = isLCSCAttributes;
exports.isArrowAttributes = isArrowAttributes;
exports.isVericalAttributes = isVericalAttributes;
exports.isTMEAttributes = isTMEAttributes;
const zod_1 = require("zod");
/**
 * Array of supported distributor UIDs
 */
exports.distributorUids = ["digikey", "lcsc", "mouser", "arrow", "verical", "tme"];
exports.DistributorAttributesSchema = zod_1.z.object({
    distributor: zod_1.z.string(),
});
exports.DigikeyDistributorAttributesSchema = zod_1.z.object({
    ...exports.DistributorAttributesSchema.shape,
    distributor: zod_1.z.literal("digikey"),
});
exports.MouserDistributorAttributesSchema = zod_1.z.object({
    ...exports.DistributorAttributesSchema.shape,
    distributor: zod_1.z.literal("mouser"),
});
exports.LCSCDistributorAttributesSchema = zod_1.z.object({
    ...exports.DistributorAttributesSchema.shape,
    distributor: zod_1.z.literal("lcsc"),
});
exports.ArrowDistributorAttributesSchema = zod_1.z.object({
    ...exports.DistributorAttributesSchema.shape,
    distributor: zod_1.z.literal("arrow"),
});
exports.VericalDistributorAttributesSchema = zod_1.z.object({
    ...exports.DistributorAttributesSchema.shape,
    distributor: zod_1.z.literal("verical"),
});
exports.TMEDistributorAttributesSchema = zod_1.z.object({
    ...exports.DistributorAttributesSchema.shape,
    distributor: zod_1.z.literal("tme"),
});
/**
 * Type guard to check if distributorAttributes is for a specific distributor
 */
function isDigikeyAttributes(attributes) {
    return attributes.distributor === "digikey";
}
/**
 * Type guard to check if distributorAttributes is for Mouser
 */
function isMouserAttributes(attributes) {
    return attributes.distributor === "mouser";
}
/**
 * Type guard to check if distributorAttributes is for LCSC
 */
function isLCSCAttributes(attributes) {
    return attributes.distributor === "lcsc";
}
/**
 * Type guard to check if distributorAttributes is for Arrow
 */
function isArrowAttributes(attributes) {
    return attributes.distributor === "arrow";
}
/**
 * Type guard to check if distributorAttributes is for Verical
 */
function isVericalAttributes(attributes) {
    return attributes.distributor === "verical";
}
/**
 * Type guard to check if distributorAttributes is for TME
 */
function isTMEAttributes(attributes) {
    return attributes.distributor === "tme";
}
//# sourceMappingURL=distributors.js.map